export const FETCH_CURRENCY_LIST_END = "fetchCurrencyListEnd";
